'use strict';
import React, { Component } from 'react';
import MontoMask from '../../../../../Common/Components/Mask/MontoMask'

class ImporteCuotaColumn extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { monto } = this.props;

        return <td rowSpan="2" style={{ width: "9%" }}>
            <MontoMask monto={monto} moneda="" />
        </td>

    }

}
export default ImporteCuotaColumn;